import { checkResponse, get, post } from "@/utils/http";
import { APP_CONFIG } from "@/utils/constants";

export function requestClassList(data) {
  return get(`${APP_CONFIG.apiUrl}/class`, data).then(checkResponse);
}

export function requestSubjectDetail(id) {
  return get(`${APP_CONFIG.apiUrl}/class/subject/${id}`).then(checkResponse);
}

export function requestPartQuestion(data) {
  return get(`${APP_CONFIG.apiUrl}/test/${data.partId}/question/${data.questionId}?action=${data.action}`).then(checkResponse);
}

export function requestQuestionResponse(data) {
  return post(`${APP_CONFIG.apiUrl}/test/question/store`, data).then(checkResponse);
}

export function requestQuestionNote(data) {
  return post(`${APP_CONFIG.apiUrl}/test/update_note`, data).then(checkResponse);
}

export function requestQuestionSave() {
  return get(`${APP_CONFIG.apiUrl}/test/saved`).then(checkResponse);
}

export function requestQuestionWrong() {
  return get(`${APP_CONFIG.apiUrl}/test/wrong`).then(checkResponse);
}

export function requestClassStatistic() {
  return get(`${APP_CONFIG.apiUrl}/test/statistic`).then(checkResponse);
}
